import { USOddsRoundingLadder } from 'constants/bcms';

export function decimalToAmericanOdds(decimalOddsNum) {
  if (decimalOddsNum >= 2.0) {
    return (decimalOddsNum - 1) * 100;
  } else {
    return -100 / (decimalOddsNum - 1);
  }
}

export function roundUSOdds(americanOddsNum, ladder) {
  // ladder is an array of numbers that helps us round the value

  let maxLadder = Number.MAX_SAFE_INTEGER;
  let minLadder = Number.MIN_SAFE_INTEGER;
  ladder.forEach(l => {
    if (americanOddsNum >= l) {
      minLadder = l;
    }
    if (americanOddsNum <= l && l < maxLadder) {
      maxLadder = l;
    }
  });
  const minLadderDiff = Math.abs(americanOddsNum) - Math.abs(minLadder);
  const maxLadderDiff = Math.abs(maxLadder) - Math.abs(americanOddsNum);
  return minLadderDiff <= maxLadderDiff ? minLadder : maxLadder; // round value up or down
}


export function americanOdds(decimalOddsNum) {
  if (decimalOddsNum <= 1.005 || decimalOddsNum > 1000) {
    return '-';
  }

  const usOdds = roundUSOdds(decimalToAmericanOdds(decimalOddsNum), USOddsRoundingLadder).toFixed(0);
  if (usOdds < 0) {
    return `${usOdds}`;
  } else {
    return `+${usOdds}`;
  }
}
